<template>
  <div class="calendar-legend">
    <span class="calendar-legend__label">Legenda</span>
    <BasePopover align="right" position="top">
      <button
        type="button"
        class="calendar-legend__trigger"
        data-test-id="calendar-legend-trigger"
        aria-label="Pokaż legendę kalendarza"
      >
        <BaseIcon name="help_outline" type="secondary" size="16" />
      </button>
      <template #popover>
        <div class="calendar-legend__content">
          <div v-for="entry in legendEntries" :key="entry.title" class="calendar-legend__entry">
            <div :class="['calendar-legend__cell', `calendar-legend__cell--${entry.variant}`]">
              30
            </div>
            <div class="calendar-legend__text">
              <span class="calendar-legend__title">{{ entry.title }}</span>
              {{ ' - ' }}
              {{ entry.description }}
            </div>
          </div>
        </div>
      </template>
    </BasePopover>
  </div>
</template>

<script lang="ts" setup>
  import BaseIcon from '@/components/BaseIcon.vue'
  import BasePopover from '@/components/BasePopover.vue'

  const legendEntries = [
    {
      description: 'ten dzień możesz wybrać jako dzień startu jadłospisu.',
      title: 'Dostępny',
      variant: 'available',
    },
    {
      description: 'na ten dzień jest już przypisany jadłospis.',
      title: 'Zajęty',
      variant: 'diet',
    },
    {
      description: 'w tym dniu jadłospis nie zmieści się bez kolizji z innym.',
      title: 'Zablokowany',
      variant: 'blocked',
    },
  ] as const
</script>

<style scoped>
  .calendar-legend {
    display: flex;
    gap: 4px;
    align-items: center;
    font-family: Inter, sans-serif;
  }

  .calendar-legend__label {
    font-size: 14px;
    font-weight: 500;
    color: var(--color-secondary-text);
  }

  .calendar-legend__trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: var(--color-tertiary-text);
    cursor: pointer;
    background: none;
    border: none;
  }

  .calendar-legend__trigger:hover {
    color: var(--color-secondary-text);
  }

  .calendar-legend__content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 276px;
    font-family: Inter, sans-serif;
    background-color: var(--color-background-bg-primary);
    border-radius: 12px;
  }

  .calendar-legend__entry {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .calendar-legend__cell {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-bottom: 0;
    font-size: 12px;
    font-weight: 500;
    border-radius: 50%;
  }

  .calendar-legend__cell--available {
    color: #2e7d32;
    background-color: #e8f5e9;
  }

  .calendar-legend__cell--diet {
    color: #5d4037;
    cursor: not-allowed;
    background-color: #ffecb3;
  }

  .calendar-legend__cell--blocked {
    color: var(--color-text-text-disabled, #9ca3af);
    text-decoration: line-through;
    cursor: not-allowed;
    background-color: var(--color-background-bg-primary, #fff);
  }

  .calendar-legend__text {
    font-size: 12px;
    color: #111827;
  }

  .calendar-legend__title {
    font-weight: 500;
  }
</style>
